// =====    ALERT CREATION ORIGINS   =====
export const JOB_INDEX_FILTER_BUTTON = 'job_index_filter_button'
export const JOB_INDEX_ALERT_AD_BUTTON = 'job_index_alert_ad_button'
export const HOME_PAGE_BUTTON = 'home_page_button'
export const JOB_INDEX_MOBILE_STICKY_BUTTON = 'job_index_mobile_sticky_button'
export const JOB_INDEX_SEE_MORE_BUTTON = 'job_index_see_more_button'
export const ARTICLE_SHOW_BUTTON = 'article_show_button'
export const SCHOOL_INDEX_PROGRAM_NEWS = 'school_index_program_news'
export const SCHOOL_INDEX_SCHOOL_NEWS = 'school_index_news'
export const SCHOOL_INDEX_HALF_PAGE = 'school_index_half_page'
export const SCHOOL_INDEX_SCHOOL_VIDEOS = 'school_index_videos'
